// Helper function to convert ArrayBuffer to hex string
function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

interface SignatureOptions {
  userId: string;
  secretKey: string;
}

export async function generateUserIdentitySignature({
  userId,
  secretKey,
}: SignatureOptions): Promise<string> {
  if (!userId || typeof userId !== "string" || userId.trim() === "") {
    throw new Error(
      "UserJot Signature Generation: `userId` must be a non-empty string."
    );
  }
  if (!secretKey || typeof secretKey !== "string" || secretKey.trim() === "") {
    throw new Error(
      "UserJot Signature Generation: `secretKey` must be a non-empty string."
    );
  }

  const keyMaterial = await crypto.subtle.importKey(
    "raw", // format
    new TextEncoder().encode(secretKey), // keyData
    { name: "HMAC", hash: "SHA-256" }, // algorithm
    false, // extractable
    ["sign"] // usages
  );

  const signatureBuffer = await crypto.subtle.sign(
    "HMAC", // algorithm
    keyMaterial, // key
    new TextEncoder().encode(userId) // data
  );

  return bufferToHex(signatureBuffer);
}
